<style scoped>

.flex-container {
  display: flex;
  flex-flow: column;
  align-items: center;
}

.message {
  text-align: center;
  border: 1px solid lightgray;
  border-radius: 10px;
  font-size: small;
  padding: 2px 15px 2px 15px;
}
</style>
<template>
  <b-col class="flex-container">
    <b-row>
      <b-col>
        <font-awesome-icon :icon="icon" :size="iconSize" :class="iconClass"/>
      </b-col>
    </b-row>
    <b-row style="height: 30px;">
      <b-col>
        <p class="message">{{message}} </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <slot></slot>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
export default {
  name: 'Message',
  props: {
    message: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    iconClass: {
      type: String,
      default: 'text-light-danger',
    },
    iconSize: {
      type: String,
      default: '2x',
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/utils/Message.vue